import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import historias from '../data/historias.json';
import { setSEO } from '../lib/seo';

const C = { navy:'#001f3a', navyMid:'#0b3558', navyDark:'#0d1f30', orange:'#f07820', orangeDk:'#9a4600', light:'#f8f9ff', white:'#ffffff' };
const LOGO_W = `${process.env.PUBLIC_URL}/LogoBlanco.png`;

const TIPOS = {
  'caso-real':   { label:'Caso real',     bg:'rgba(15,118,110,.1)',  color:'#0a5c52', border:'rgba(15,118,110,.25)', side:'linear-gradient(160deg,#001f3a,#0b3558)' },
  'estrategia':  { label:'Estrategia',    bg:'rgba(240,120,32,.08)', color:'#7a3e0e', border:'rgba(240,120,32,.3)',  side:'linear-gradient(160deg,#2d1a00,#7a3e0e)' },
  'guia':        { label:'Guia practica', bg:'rgba(37,99,235,.08)',  color:'#1e3a8a', border:'rgba(37,99,235,.25)', side:'linear-gradient(160deg,#0c1a40,#1e3a8a)' },
  'metodologia': { label:'Metodologia',   bg:'rgba(124,58,237,.08)', color:'#4c1d95', border:'rgba(124,58,237,.25)',side:'linear-gradient(160deg,#1a0a2e,#4c1d95)' },
};

export default function WebHistoriaDetalle() {
  const { id } = useParams();
  const historia = historias.find(h => h.id === id);

  useEffect(() => {
    if (!historia) return;
    setSEO({
      title: `${historia.titulo} | HireMeUp`,
      description: historia.extracto,
      canonical: `https://hiremeupglobal.com/historias/${historia.id}`,
    });
  }, [historia]);

  if (!historia) {
    return (
      <div style={{ minHeight:'100vh', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', background:C.light, gap:'16px' }}>
        <div className="d" style={{ fontFamily:'Manrope,sans-serif', fontSize:'24px', fontWeight:900, color:C.navy }}>Historia no encontrada</div>
        <a href="/historias" style={{ color:C.orange, fontSize:'14px', fontWeight:700 }}>← Volver a historias</a>
      </div>
    );
  }

  const tipo = TIPOS[historia.tipo];

  const S = `
    @import url('https://fonts.googleapis.com/css2?family=Manrope:wght@700;800;900&family=Inter:wght@300;400;500;600;700&display=swap');
    *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
    body{font-family:'Inter',sans-serif;background:${C.light};color:${C.navy}}
    .d{font-family:'Manrope',sans-serif} a{text-decoration:none}
    .bo{background:linear-gradient(135deg,${C.orange},${C.orangeDk});color:white;border:none;cursor:pointer;font-family:'Inter',sans-serif;font-weight:700;transition:opacity .18s;display:inline-flex;align-items:center;gap:8px}
    .bo:hover{opacity:.9}
  `;

  return (
    <>
      <style>{S}</style>

      {/* NAVBAR */}
      <nav style={{ background:C.navy, height:'56px', display:'flex', alignItems:'center', justifyContent:'space-between', padding:'0 40px', position:'sticky', top:0, zIndex:100 }}>
        <a href="/"><img src={LOGO_W} alt="HireMeUp" style={{ height:'32px', objectFit:'contain' }} /></a>
        <div style={{ display:'flex', gap:'10px' }}>
          <a href="https://app.hiremeupglobal.com/login" style={{ color:'rgba(255,255,255,.7)', fontSize:'13px', padding:'7px 14px', borderRadius:'8px', border:'1.5px solid rgba(255,255,255,.2)' }}>Ingresar</a>
          <a href="https://app.hiremeupglobal.com/register" className="bo" style={{ padding:'7px 16px', borderRadius:'8px', fontSize:'13px' }}>Empezar gratis</a>
        </div>
      </nav>

      {/* HERO ARTÍCULO */}
      <section style={{ background:`linear-gradient(135deg,${C.navy},${C.navyMid})`, padding:'48px 40px 40px' }}>
      
         <div style={{ maxWidth:'900px', margin:'0 auto', display:'flex', alignItems:'center', gap:'60px', flexWrap:'wrap' }}>
  {/* Texto izquierda */}
  <div style={{ flex:1, minWidth:'260px' }}>
    <div style={{ display:'inline-flex', alignItems:'center', gap:'6px', background:'rgba(240,120,32,.12)', border:'1px solid rgba(240,120,32,.25)', borderRadius:'20px', padding:'4px 14px', marginBottom:'20px' }}>
      <div style={{ width:'5px', height:'5px', borderRadius:'50%', background:C.orange }} />
      <span style={{ fontSize:'10px', fontWeight:700, color:C.orange, letterSpacing:'.12em', textTransform:'uppercase' }}>Historias reales · Sin filtro</span>
    </div>
    <h1 className="d" style={{ fontSize:'clamp(2rem,5vw,3rem)', fontWeight:900, color:'white', letterSpacing:'-.03em', lineHeight:1.05, marginBottom:'12px' }}>
      El trabajo remoto<br />no es suerte.<br /><span style={{ color:C.orange }}>Es estrategia.</span>
    </h1>
    <p style={{ fontSize:'15px', color:'rgba(255,255,255,.5)', lineHeight:1.7, maxWidth:'480px', marginBottom:'28px' }}>
      Casos reales de profesionales de LATAM que cambiaron su trayectoria con metodología, no con magia.
    </p>
    <div style={{ display:'flex', gap:'28px' }}>
      {[['600+','Profesionales activos'],['68%','Más entrevistas en 30 días'],['+10','Países LATAM']].map(([n,l]) => (
        <div key={n}>
          <div className="d" style={{ fontSize:'24px', fontWeight:900, color:C.orange, letterSpacing:'-.03em', lineHeight:1 }}>{n}</div>
          <div style={{ fontSize:'10px', color:'rgba(255,255,255,.35)', marginTop:'3px' }}>{l}</div>
        </div>
      ))}
    </div>
  </div>
  {/* Logo derecha */}
  <div style={{ flex:'0 0 260px', display:'flex', justifyContent:'center', alignItems:'center' }}>
    <img src={LOGO_W} alt="HireMeUp" style={{ width:'220px', objectFit:'contain', opacity:.92 }} />
  </div>
</div>
      </section>

      {/* CONTENIDO */}
      <article style={{ maxWidth:'720px', margin:'0 auto', padding:'48px 40px' }}>
        {historia.contenido.map((bloque, i) => {
          if (bloque.tipo === 'parrafo') return (
            <p key={i} style={{ fontSize:'16px', lineHeight:1.8, color:'rgba(0,31,58,.75)', marginBottom:'24px', fontWeight:300 }}>{bloque.texto}</p>
          );
          if (bloque.tipo === 'highlight') return (
            <div key={i} style={{ borderLeft:`3px solid ${C.orange}`, paddingLeft:'20px', margin:'32px 0', background:'rgba(240,120,32,.04)', borderRadius:'0 8px 8px 0', padding:'16px 20px' }}>
              <p className="d" style={{ fontSize:'17px', fontWeight:800, color:C.navy, lineHeight:1.4, letterSpacing:'-.01em' }}>{bloque.texto}</p>
            </div>
          );
          if (bloque.tipo === 'conclusion') return (
            <div key={i} style={{ background:`linear-gradient(135deg,${C.navy},${C.navyMid})`, borderRadius:'14px', padding:'24px 28px', marginTop:'32px' }}>
              <p className="d" style={{ fontSize:'16px', fontWeight:800, color:'white', lineHeight:1.5, letterSpacing:'-.01em' }}>{bloque.texto}</p>
            </div>
          );
          return null;
        })}
      </article>

      {/* CTA ARTÍCULO */}
      <div style={{ maxWidth:'720px', margin:'0 auto 48px', padding:'0 40px' }}>
        <div style={{ background:`linear-gradient(135deg,${C.navy},${C.navyMid})`, borderRadius:'16px', padding:'32px', display:'flex', alignItems:'center', justifyContent:'space-between', gap:'20px', flexWrap:'wrap' }}>
          <div>
            <div className="d" style={{ fontSize:'18px', fontWeight:900, color:'white', marginBottom:'6px' }}>¿Quieres que tu historia sea la próxima?</div>
            <div style={{ fontSize:'13px', color:'rgba(255,255,255,.45)' }}>Accede a HireMeApp, el generador de CV y la metodología HireMeUp.</div>
          </div>
          <a href="https://app.hiremeupglobal.com/register" className="bo" style={{ padding:'12px 24px', borderRadius:'10px', fontSize:'14px', flexShrink:0 }}>Empieza gratis →</a>
        </div>
      </div>

      {/* MÁS HISTORIAS */}
      <div style={{ maxWidth:'720px', margin:'0 auto', padding:'0 40px 48px' }}>
        <div className="d" style={{ fontSize:'16px', fontWeight:800, color:C.navy, marginBottom:'16px' }}>Más historias</div>
        <div style={{ display:'flex', flexDirection:'column', gap:'10px' }}>
          {historias.filter(h => h.id !== historia.id).slice(0, 3).map(h => {
            const t = TIPOS[h.tipo];
            return (
              <a key={h.id} href={`/historias/${h.id}`} style={{ display:'flex', alignItems:'center', gap:'14px', background:'white', borderRadius:'12px', padding:'14px 16px', border:'0.5px solid rgba(0,31,58,.07)' }}>
                <div style={{ width:'36px', height:'36px', borderRadius:'50%', background:t.side, display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'Manrope,sans-serif', fontSize:'14px', fontWeight:900, color:'white', flexShrink:0 }}>{h.avatar}</div>
                <div style={{ flex:1 }}>
                  <div style={{ fontSize:'13px', fontWeight:700, color:C.navy, lineHeight:1.3, marginBottom:'2px' }}>{h.titulo}</div>
                  <span style={{ fontSize:'9px', fontWeight:700, padding:'2px 8px', borderRadius:'10px', background:t.bg, color:t.color, border:`1px solid ${t.border}`, textTransform:'uppercase', letterSpacing:'.06em' }}>{t.label}</span>
                </div>
                <span style={{ fontSize:'12px', color:C.orange, fontWeight:700, flexShrink:0 }}>→</span>
              </a>
            );
          })}
        </div>
      </div>

      <footer style={{ background:C.navyDark, padding:'20px 40px', borderTop:'1px solid rgba(255,255,255,.06)', display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:'12px' }}>
        <img src={LOGO_W} alt="HireMeUp" style={{ height:'38px', objectFit:'contain' }} />
        <p style={{ fontSize:'12px', color:'rgba(255,255,255,.2)' }}> 2026 HireMeUp Global</p>
      </footer>
    </>
  );
}
